<section [editableInStoryblok]="_editable" data-test-class="tile-group-section">
	<span
		[heading]="headingType()"
		class="h2 mb-4 font-display font-normal"
		data-test-id="tile-group-title"
		vc-heading
	>
		{{ title() }}
	</span>
	<div class="grid grid-cols-2 gap-2">
		@for (tile of tiles(); track $index) {
			<div
				[attr.data-test-id]="'tile-group-tile-' + $index"
				[ngClass]="{ 'col-span-2': $last && $even }"
				(click)="onTileClick(tile)"
				data-test-class="tile-group-tile"
			>
				<vp-tile
					[icon]="tile.icon"
					[id]="_uid + '-trigger-sheet'"
					[preventClickEvents]="true"
					[title]="tile.title"
				/>
			</div>
		}
	</div>
</section>

<vp-sheet
	[attr.data-test-id]="_uid + '-tile-group-sheet'"
	[isLoading]="false"
	[triggerId]="_uid + '-trigger-sheet'"
	(emitClose)="onSheetClose()"
>
	<vp-sheet-header>
		<span class="heading-group">
			{{ selectedTile()?.title }}
		</span>
	</vp-sheet-header>
	<vp-sheet-content id="sheet-content">
		@if (selectedTile()) {
			<sb-richtext
				[content]="selectedTile().description"
				[richTextResolvers]="richTextResolvers()"
			/>
		}
	</vp-sheet-content>
</vp-sheet>
